module.exports = __webpack_public_path__ + "img/dsci0017.6d73487e.jpg";